/**
 * Servicio para gestionar el carrito de compras en localStorage
 */

const CART_STORAGE_KEY = 'shopping_cart';

const cartService = {
  /**
   * Obtener el carrito actual
   */
  getCart() {
    try {
      const cart = localStorage.getItem(CART_STORAGE_KEY);
      return cart ? JSON.parse(cart) : { items: [], total: 0 };
    } catch (error) {
      console.error('Error al obtener carrito:', error);
      return { items: [], total: 0 };
    }
  },

  /**
   * Guardar el carrito
   */
  saveCart(cart) {
    try {
      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
      return true;
    } catch (error) {
      console.error('Error al guardar carrito:', error);
      return false;
    }
  },

  /**
   * Agregar producto al carrito
   */
  addItem(product, quantity = 1) {
    const cart = this.getCart();
    
    // Verificar si el producto ya existe
    const existingItemIndex = cart.items.findIndex(
      item => item.productId === product.id
    );

    if (existingItemIndex > -1) {
      // Actualizar cantidad
      cart.items[existingItemIndex].quantity += quantity;
    } else {
      // Agregar nuevo item
      cart.items.push({
        productId: product.id,
        name: product.name,
        code: product.code,
        price: product.precio,
        quantity: quantity,
        image: product.image,
        stock: product.stock
      });
    }

    // Recalcular total
    cart.total = cart.items.reduce((sum, item) => 
      sum + (item.price * item.quantity), 0
    );

    this.saveCart(cart);
    return cart;
  },

  /**
   * Actualizar cantidad de un item
   */
  updateQuantity(productId, quantity) {
    if (quantity < 1) {
      return this.removeItem(productId);
    }

    const cart = this.getCart();
    const itemIndex = cart.items.findIndex(item => item.productId === productId);

    if (itemIndex > -1) {
      cart.items[itemIndex].quantity = quantity;
      
      // Recalcular total
      cart.total = cart.items.reduce((sum, item) => 
        sum + (item.price * item.quantity), 0
      );

      this.saveCart(cart);
    }

    return cart;
  },

  /**
   * Remover item del carrito
   */
  removeItem(productId) {
    const cart = this.getCart();
    cart.items = cart.items.filter(item => item.productId !== productId);
    
    // Recalcular total
    cart.total = cart.items.reduce((sum, item) => 
      sum + (item.price * item.quantity), 0
    );

    this.saveCart(cart);
    return cart;
  },

  /**
   * Limpiar carrito
   */
  clearCart() {
    const emptyCart = { items: [], total: 0 };
    this.saveCart(emptyCart);
    return emptyCart;
  },

  /**
   * Obtener cantidad total de items
   */
  getItemCount() {
    const cart = this.getCart();
    return cart.items.reduce((sum, item) => sum + item.quantity, 0);
  },

  /**
   * Verificar si un producto está en el carrito
   */
  isInCart(productId) {
    const cart = this.getCart();
    return cart.items.some(item => item.productId === productId);
  },

  /**
   * Obtener cantidad de un producto en el carrito
   */
  getProductQuantity(productId) {
    const cart = this.getCart();
    const item = cart.items.find(item => item.productId === productId);
    return item ? item.quantity : 0;
  }
};

export default cartService;

